import { FormControl, IFormControlProps } from 'native-base';

type FormErrorInputProps = IFormControlProps;

export function FormErrorInput({ children, ...props }: FormErrorInputProps): JSX.Element {
  return <FormControl.ErrorMessage {...props}>{children}</FormControl.ErrorMessage>;
}
